var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElNotAllowedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM3.408 9.17777C3.02218 8.54276 2.8 7.79733 2.8 7C2.8 4.6804 4.6804 2.8 7 2.8C7.79733 2.8 8.54276 3.02218 9.17777 3.408L3.408 9.17777ZM4.82221 10.592C5.45722 10.9778 6.20266 11.2 7 11.2C9.3196 11.2 11.2 9.3196 11.2 7C11.2 6.20266 10.9778 5.45722 10.592 4.82221L4.82221 10.592Z",
    fill: "#222222",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElNotAllowedLight);
export default __webpack_public_path__ + "static/media/el-not-allowed-light.205eaec509ca24f110493800c0912cd2.svg";
export { ForwardRef as ReactComponent };